import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { Download } from 'lucide-react';
export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleDownloadResume = () => {
    window.open('https://heyzine.com/flip-book/aa65e914ab.html', '_blank');
  };
  return <div id="hero" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0f172a] via-[#1e3a8a] to-[#1e293b] text-white overflow-hidden" data-id="element-137" data-mp="127ect9b6vhbc">
      {/* Animated Silver Gradient Overlay */}
      <div className="absolute inset-0 opacity-30" data-id="element-138" data-mp="ncq29gqxlsov">
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gradient-to-bl from-gray-300/40 via-transparent to-transparent blur-3xl animate-pulse" data-id="element-139" data-mp="neawf59c39m7"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-gradient-to-tr from-blue-300/30 via-transparent to-transparent blur-3xl animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-140" data-mp="381e1rd3l65u1"></div>
      </div>

      {/* Metallic Grid Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-141" data-mp="399bavmrkdbvg">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(192,192,192,0.1)_1px,transparent_1px),linear-gradient(90deg,rgba(192,192,192,0.1)_1px,transparent_1px)] bg-[size:50px_50px]" data-id="element-142" data-mp="39cpfz2rm3z6l"></div>
      </div>

      {/* Silver Shine Effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -skew-x-12 animate-shimmer" data-id="element-143" data-mp="359t0hkxdcj6v"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10 pt-20 pb-16" data-id="element-144" data-mp="2qlod43ndfjhr">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center" data-id="element-145" data-mp="2vjg9payyntsa">
          {/* Photo Section */}
          <FadeIn delay={0.1} className="lg:col-span-2 flex justify-center lg:justify-end" data-id="element-146" data-mp="2hl9td8q22cgd">
            <div className="relative group" data-id="element-147" data-mp="s1rpyhl8dur4">
              {/* Metallic Glow Behind Photo */}
              <div className="absolute inset-0 bg-gradient-to-br from-gray-300/40 via-blue-300/30 to-gray-400/40 rounded-2xl transform rotate-3 blur-2xl group-hover:blur-3xl transition-all duration-500" data-id="element-148" data-mp="nbbdp0t5cf6c"></div>

              {/* Silver Border Effect */}
              <div className="absolute -inset-1 bg-gradient-to-br from-gray-300 via-gray-100 to-gray-400 rounded-2xl opacity-75 blur-sm" data-id="element-149" data-mp="deq74b1haw0e"></div>

              <img src="https://cdn.magicpatterns.com/uploads/1WAds7BtrN1Ci8vKPYQyAK/Albert_Previte.jpg" alt="Albert Previte" className="relative w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 object-cover rounded-2xl shadow-2xl border-4 border-white/20 backdrop-blur-sm" data-id="element-150" data-mp="161t1qs31amld" />

              {/* Shine Overlay on Hover */}
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl" data-id="element-151" data-mp="3lqudvm65c340"></div>
            </div>
          </FadeIn>

          {/* Content Section */}
          <div className="lg:col-span-3 text-center lg:text-left" data-id="element-152" data-mp="21bxwp0pekk98">
            <FadeIn delay={0.2} data-id="element-153" data-mp="26a96xcjm0wrz">
              <h2 className="text-transparent bg-clip-text bg-gradient-to-r from-gray-200 via-white to-gray-300 font-medium tracking-wider uppercase text-sm mb-4 drop-shadow-lg" data-id="element-154" data-mp="2697m4gcskvx2">
                Director, Enterprise Project & Program Management
              </h2>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-155" data-mp="2ky40sw9ct76n">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 leading-tight text-transparent bg-clip-text bg-gradient-to-r from-white via-gray-100 to-white drop-shadow-2xl" data-id="element-156" data-mp="2kx2gs2ad1acs">
                Enterprise Program Leader Driving Large-Scale Transformation
              </h1>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-157" data-mp="uou4pe6sk4dj">
              <p className="text-base md:text-lg lg:text-xl text-gray-200 mb-4 leading-relaxed drop-shadow-lg" data-id="element-158" data-mp="zkr8kl0vbi9f">
                Information Technology, Healthcare, Commercial & Government
                Consulting
              </p>
            </FadeIn>

            <FadeIn delay={0.45} data-id="element-159" data-mp="3vjrrs73hbnpy">
              <p className="text-base md:text-lg text-gray-300 mb-10 leading-relaxed drop-shadow-lg" data-id="element-160" data-mp="ea3iljp7qea5">
                Translating strategy into executable roadmaps, standardizing
                governance, and delivering complex, multi-stakeholder
                initiatives using agile and SDLC frameworks across commercial,
                federal, healthcare, and technology environments.
              </p>
            </FadeIn>

            <FadeIn delay={0.5} className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start flex-wrap" data-id="element-161" data-mp="3rgvg70ccwrvi">
              <Button variant="secondary" onClick={() => scrollToSection('experience')} className="min-w-[160px] shadow-xl shadow-blue-900/30 hover:shadow-2xl hover:shadow-blue-800/40 transition-shadow" data-id="element-162" data-mp="2yzj0tqad8uo6">
                View Experience
              </Button>
              <Button variant="outline" onClick={() => scrollToSection('contact')} className="min-w-[160px] backdrop-blur-sm bg-white/5 hover:bg-white/10 shadow-xl shadow-gray-900/30" data-id="element-163" data-mp="1eafcom3pzeui">
                Contact Me
              </Button>
              <Button variant="primary" onClick={handleDownloadResume} className="min-w-[160px] bg-gradient-to-r from-gray-200 to-gray-300 text-[#1e3a8a] hover:from-white hover:to-gray-200 border-none shadow-xl shadow-gray-400/20 hover:shadow-2xl hover:shadow-gray-300/30 transition-all font-semibold" data-id="element-164" data-mp="1sa6m09jak726">
                <Download className="mr-2 w-5 h-5" data-id="element-165" data-mp="7tbhr6vkdt72" />
                View Resume
              </Button>
            </FadeIn>
          </div>
        </div>
      </div>
    </div>;
}